<template>
  <div>
    <cebianlan></cebianlan>
    <!-- 头部 -->
    <banner></banner>
    <!-- 轮播图 -->
    <div style=" min-width: 972px;overflow: hidden; background-color: #f5f6f7" class="lunboBanner">
      <CarouselPic/>
      <!-- 精品课程 -->
      <div style="overflow: hidden" class="quality-course">
        <div style="margin: 0 auto; width: 244px; height: 36px; margin-top: 60px; overflow: hidden">
          <img class="zuo" src="./images/zuo@2x.png" alt="" />
          <span class="gongkai" style="margin-left: 20px">精品课程</span>
          <img class="zuo" style="margin-left: 20px" src="./images/you@2x.png" alt="" />
        </div>
        <div v-for="item in listCates" :key="item.id" class="jinli">
          <CourseListContent :cateId="item" />
        </div>
      </div>
      <!-- <bottom></bottom> -->
      <Footer></Footer>
      <bottomlist></bottomlist>
    </div>
  </div>
</template>
<script>
import banner from './banner'
// import bottom from './bottom'
import bottomlist from './bottomlist'
import Footer from './mofang/footer.vue'
import cebianlan from './cebianlan'
import CourseListContent from './CourseListContent'
import CarouselPic from './components/carouselPic.vue'
import {mapState } from 'vuex'

export default {
  data() {
    return {
      coursesa: [],
      courses: [],
      listCates: [],
      orgInfo: '',
      webInfo: {},
    }
  },
  components: {
    banner,
    // bottom,
    bottomlist,
    Footer,
    cebianlan,
    CourseListContent, 
    CarouselPic                 
  },
  created() {
    this.$store.dispatch('getOrgID', this.$store.state.domain).then(()=>{
      this.getListCates()
    })
  },
  computed: {
    ...mapState(['org_id'])
  },
  methods: {
    tiaozhuanlist(item) {
      if(!item.jump_path) return
      if(item.is_new_window == 2){
        window.open(item.jump_path, '_self')
      }else {
        window.open(item.jump_path)
      }
      
      // this.$router.push(item.jump_path);
    },
    // 获取轮播图
    banners() {
      const data = {
        org_id: this.org_id
      }
      this.$axios
        .post('/stu/course/banners', data)
        .then((res) => {
          if (res.data.code === 200) {
            this.bannerss = res.data.data
          }
        })
        .catch((err) => console.log(err))
    },
    once: function (fn) {
      let caller = true
      return function () {
        if (caller) {
          caller = false
          fn.apply(this, arguments)
        }
      }
    },

    setSize1: function () {
      var width =
        window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth
      this.screenWidth = width
      //图片                高 / 宽  700 / 1920
      this.bannerHeight = (440 / 1920) * this.screenWidth
      if (document.getElementById('el-carousel')) {
        document.getElementById('el-carousel').style.height =
        this.bannerHeight + 'px'
      }
      
    },

    setSize: function () {
      this.bannerHeight = (440 / 1920) * this.screenWidth
      if (document.getElementById('el-carousel')) {
        document.getElementById('el-carousel').style.height =
        this.bannerHeight + 'px'
      }
    },

    // 查询科目树
    getListCates() {
      const data = {
        org_id: this.org_id,
      }
      this.$axios.post('/stu/cate/listCates', data).then((res) => {
        if (res.data.code === 200) {
          this.listCates = res.data.data
        }
      })
    }
  },
}
</script>
<style scoped>
* {
  margin: 0;
  padding: 0;
}

a {
  text-decoration: none;
}

/* 头部 */
.toubu {
  width: 100%;
  height: 64px;
  opacity: 1;
  background: #fff;
  box-shadow: 0px 1px 0px 0px #e8eaec;
  overflow: hidden;
}

.toubuyi {
  width: 1244px;
  height: 64px;
  margin: 0 auto;
  /* background: #f5f5f5; */
}

.logo {
  opacity: 1;
  font-size: 20px;
  font-family: DINPro, DINPro-Black;
  font-weight: 900;
  text-align: left;
  color: #10a675;
  line-height: 26px;
  float: left;
  line-height: 64px;
}

.toubuwz li:hover {
  background-color: #10a675;
  color: #fff;
}

.toubuwz li {
  list-style-type: none;
  width: 88px;
  height: 64px;
  line-height: 64px;
  text-align: center;
  float: left;
  margin-left: 5px;
  font-size: 16px;
  color: #202020;
  text-decoration: none;
}

#list .current {
  background-color: #10a675;
  color: #fff;
}

.shuru {
  width: 260px;
  height: 36px;
  opacity: 1;
  background: #ffffff;
  border: 1px solid #10a675;
  border-radius: 19px;
  margin-top: 14px;
  margin-left: 100px;
  float: left;
  padding-left: 18px;
}

input:focus {
  outline: none;
}

.denglu {
  padding: 7px 25px;
  opacity: 1;
  border-radius: 18px;
  line-height: 64px;
  color: #10a675;
  margin-left: 200px;
}

.denglu:hover {
  background-color: #10a675;
  color: #fff;
}

.zhuce {
  padding: 7px 23px;
  opacity: 1;
  border-radius: 18px;
  line-height: 64px;
  color: #10a675;
}

.zhuce:hover {
  background-color: #10a675;
  color: #fff;
}

/* 轮播图部分 */
/* @media screen and (min-width: 1200px) {
  .lunboBanner /deep/ .el-carousel__container {
    height: 348px;
  }
}
@media screen and (max-width: 1200px) {
  .lunboBanner /deep/ .el-carousel__container {
    height: 222px;
  }
} */

.lunboBanner /deep/ .el-carousel__container {
  height: 100% !important;
}

#content {
  width: 100%;
  height: 350px;
  position: relative;
}

.carousel-inner {
  position: relative;
  width: 100%;
  overflow: hidden;
  height: 100%;
}

.carousel-inner > .item > img {
  display: block;
  line-height: 1;
  z-index: 1;
}

.carousel-indicators {
  position: absolute;
  bottom: 10px;
  left: 44%;
  z-index: 2;
  list-style-type: none;
}

.carousel-indicators li {
  display: inline-block;
  padding: 0 15px;
  font-size: 24px;
  color: #999;
  cursor: pointer;
  z-index: 2;
  opacity: 1;
}

.active1 {
  font-size: 28px;
  color: #fff;
}

.carousel-control {
  position: absolute;
  text-decoration: none;
  color: #999;
  font-weight: bold;
  opacity: 0.5;
  font-size: 40px;
  z-index: 3;
}

.carousel-control:hover {
  color: fff;
  text-decoration: none;
  opacity: 0.9;
  outline: none;
  font-size: 42px;
}

.prev {
  top: 30%;
  left: 20px;
}

.next {
  top: 30%;
  right: 20px;
}

/* 体验一节公开课 */
.tiyan {
  width: 100%;
  height: 701px;
  overflow: hidden;
}

.zuo {
  height: 22px;
  width: 38px;
  float: left;
  margin-top: 7px;
}

.gongkai {
  float: left;
  opacity: 1;
  font-size: 32px;
  font-family: MicrosoftYaHei, MicrosoftYaHei-Bold;
  font-weight: 700;
  text-align: left;
  color: #202020;
  line-height: 36px;
}

.tiyanyi {
  width: 1260px;
  height: 420px;
  margin: 0 auto;
  margin-top: 42px;
}

.zaoxing {
  width: 620px;
  height: 200px;
  background-color: #fff;
  float: left;
}

.zaoxingyi {
  width: 300px;
  height: 200px;
  opacity: 1;
  float: left;
}

.zaoxinger {
  width: 320px;
  height: 200px;
  opacity: 1;
  float: left;
}

.mianfei {
  opacity: 1;
  font-size: 22px;
  font-family: MicrosoftYaHei, MicrosoftYaHei-Bold;
  font-weight: 700;
  text-align: left;
  color: #20242f;
  margin: 33px 19px 0px 30px;
}

.guankan {
  opacity: 1;
  font-size: 14px;
  font-family: MicrosoftYaHei;
  text-align: left;
  color: #808695;
  margin-left: 30px;
}

.bofang {
  width: 48px;
  height: 48px;
  margin-left: 147px;
}

.chakan {
  width: 200px;
  height: 48px;
  opacity: 1;
  border: 1px solid #19ba8f;
  border-radius: 25px;
  color: #19ba8f;
  font-size: 18px;
}
.jinli {
  /* width: 1280px; */
  height: 100%;
  margin: 0 auto;
  margin-top: 43px;
  overflow: hidden;
}

.quality-course {
  margin-bottom: 60px;
  min-width: 972px;
}

#bbb {
  margin-top: 3px;
}

#bbb li {
  list-style-type: none;
  width: 108px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  float: left;
  margin-left: 5px;
}

#bbb li.current {
  background-color: #10a675;
  color: #fff;
}

#bbb li {
  text-decoration: none;
}

.toubuwzer li:hover {
  background-color: #10a675;
  color: #fff;
}

.toubuwzer li:hover {
  background-color: #10a675;
  color: #fff;
}

.toubuwzer li {
  color: #202020;
}

.zixueyi {
  width: 300px;
  height: 300px;
  background: url(./images/fenleisan.png);
  float: left;
}

/* 名师荟萃，教资无忧 */
.mingshi {
  width: 1260px;
  height: 340px;
  margin: 0 auto;
  margin-top: 50px;
  overflow: hidden;
}

.lxy {
  opacity: 1;
  font-size: 18px;
  font-family: HiraginoSansGB, HiraginoSansGB-W6;
  font-weight: W6;
  color: #232836;
  margin-top: 15px;
  margin-left: 20px;
}

.guoji {
  opacity: 1;
  font-size: 14px;
  font-family: PingFangSC, PingFangSC-Regular;
  font-weight: 400;
  text-align: left;
  color: #7d838b;
  margin-top: 8px;
  margin-left: 20px;
}

/* 尾部 */
.weibu {
  width: 100%;
  height: 258px;
  opacity: 1;
  background: #101115;
}

.tengface {
  opacity: 1;
  font-size: 24px;
  font-family: baotuculangti;
  text-align: left;
  color: #82858a;
}

.hezuo {
  opacity: 1;
  font-size: 14px;
  font-family: HiraginoSansGB, HiraginoSansGB-W3;
  font-weight: W3;
  text-align: left;
  color: #82858a;
}

.tengfaceyi {
  width: 100%;
  height: 49px;
  opacity: 1;
  background: #0c0d10;
  margin-top: 209px;
  overflow: hidden;
}

.suoyou {
  opacity: 1;
  font-size: 14px;
  font-family: MicrosoftYaHei;
  text-align: center;
  color: #82858a;
  line-height: 19px;
  margin-top: 12px;
}
.carousel-img {
  height: 100%;
  background-size: 100% auto;
  background-position: center;
  background-repeat: no-repeat;
}
</style>
